import { RegistrationModule } from './modules/jobseeker-registration/registration.module';
import { CommunicationGuidelineComponent } from './modules/jobseeker-registration/modals/communication-guideline/communication-guideline.component';
import { GuidelinesComponent } from './modules/jobseeker-registration/modals/guidelines/guidelines.component';
import { FooterComponent } from './modules/shared/footer/footer.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NavbarComponent } from './modules/shared/navbar/navbar.component';
import { SocialMediaShareComponent } from './modules/shared/social-media-share/social-media-share.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { ShareRedirectComponent } from './modules/share-redirect/share-redirect.component';
import { ForgotPasswordComponent } from './modules/shared/forgot-password/forgot-password.component';
import { PasswordManagerComponent } from './modules/shared/password-manager/password-manager.component';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule, MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule, MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GamificationComponent } from './modules/shared/gamification/gamification.component';
import { SafeHtmlPipe } from './pipes/safe-html/safe-html.pipe';
import { ResumeReferralDetailsComponent } from './modules/resume-referral/resume-referral-details/resume-referral-details.component';
import { FileUploadComponent } from './modules/shared/file-upload/file-upload.component';
import { JobDetailsComponent } from './modules/job-details/job-details.component';
import { ApprovalComponent } from './modules/approval/approval.component';
import { ResumeReferralCopyComponent } from './modules/resume-referral-copy/resume-referral-copy.component';
import { RequirementApprovalComponent } from './modules/requirement-approval/requirement-approval.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatExpansionModule } from '@angular/material/expansion';
import { FilterPipe } from './filters/filters.pipe';
import { ConfirmationComponent } from './modules/shared/confirmation/confirmation.component';
import { SelectSearchComponent } from './modules/shared/select-search/select-search.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoaderModule } from './modules/loader/loader.module';
import { IjpComponent } from './modules/ijp/ijp.component';
import { ImageCropperModule, ImageCropperComponent } from 'ngx-image-cropper';
import { UserImageCropperComponent } from './modules/shared/user-image-cropper/user-image-cropper.component';
import { DynamicControlsModule } from './controls/dynamic-controls.module';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpLoaderFactory, SharedModule } from './shared.module';
import { Dateformat, TimeFormat, FulltimeFormat, timeAgo } from './pipes/shared/date/dateformat';
import { StaticMasterPipe } from './pipes/shared/masterTitle-pipe/master-title.pipe';
import { MyJobsComponent } from './modules/my-jobs/my-jobs.component';
import { FilesModalComponent } from './controls/components/files-modal/files-modal.component';
import { FilesService } from './controls/services/files/files.service';
import { ConfirmationComponentCopy } from './modules/confirmation-copy/confirmation.component';
import { ProfileSettingsComponent } from './modules/shared/profile-settings/profile-settings.component';
import { ReferAFriendComponent } from './modules/dynamic/refer-a-friend/refer-a-friend.component';
import { InternalJobPostingComponent } from './modules/dynamic/internal-job-posting/internal-job-posting.component';
import { MyJourneyModule } from './modules/my-journey/my-journey.module';
import { SimilarJobViewComponent } from './modules/ijp/similar-job-view/similar-job-view.component';
import { LoginComponentV2 } from './modules/login-v2/login.component';
import { SocialMediaRedirectComponent } from './modules/login-v2/social-media-redirect/social-media-redirect.component';
import { UserProfileComponent } from './modules/user-profile/user-profile/user-profile.component';
import { AppliedFiltersCountComponent } from './modules/ijp/applied-filters-count/applied-filters-count.component';
import { environment } from "../environments/environment";
import { initializeApp } from 'firebase/app';
initializeApp(environment.firebase);

@NgModule({
    declarations: [
        AppComponent,
        LoginComponentV2,
        SocialMediaRedirectComponent,
        NavbarComponent,
        SocialMediaShareComponent,
        ShareRedirectComponent,
        ForgotPasswordComponent,
        PasswordManagerComponent,
        GamificationComponent,
        SafeHtmlPipe,
        ResumeReferralDetailsComponent,
        // FilesComponentDuplicate,
        FileUploadComponent,
        JobDetailsComponent,
        ApprovalComponent,
        ResumeReferralCopyComponent,
        RequirementApprovalComponent,
        FilterPipe,
        ConfirmationComponent,
        SelectSearchComponent,
        IjpComponent,
        UserImageCropperComponent,
        Dateformat,
        TimeFormat,
        FulltimeFormat,
        timeAgo,
        StaticMasterPipe,
        MyJobsComponent,
        ConfirmationComponentCopy,
        ProfileSettingsComponent,
        ReferAFriendComponent,
        InternalJobPostingComponent,
        FooterComponent,
        GuidelinesComponent,
        CommunicationGuidelineComponent,
        SimilarJobViewComponent,
        UserProfileComponent,
        AppliedFiltersCountComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        MatDialogModule,
        MatInputModule,
        BrowserAnimationsModule,
        ScrollingModule,
        ReactiveFormsModule,
        MatIconModule,
        FormsModule,
        MatMenuModule,
        MatCardModule,
        MatInputModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatRadioModule,
        MatButtonModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        MatSnackBarModule,
        MatButtonToggleModule,
        MatStepperModule,
        MatExpansionModule,
        MatTooltipModule,
        MatSnackBarModule,
        MatButtonModule,
        NgbModule,
        LoaderModule,
        ImageCropperModule,
        DynamicControlsModule,
        MyJourneyModule,
        TranslateModule.forRoot({
            loader: {
              provide: TranslateLoader,
              useFactory: HttpLoaderFactory,
              deps: [HttpClient]
            }
        }),
        SharedModule,
        MatTabsModule,
        RegistrationModule
    ],
    providers: [
        { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 2500 } },
        { provide: MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS, useValue: { diameter: 20 } },
        FilesModalComponent,
        FilesService
    ],
    exports: [],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class AppModule { }
